__turbopack_context__.v({
  "fade-in": "SharpnessAgeBugs-module-scss-module__584AFW__fade-in",
  "inner": "SharpnessAgeBugs-module-scss-module__584AFW__inner",
  "isActive": "SharpnessAgeBugs-module-scss-module__584AFW__isActive",
  "root": "SharpnessAgeBugs-module-scss-module__584AFW__root",
});
